import clsx from "clsx"

interface IconProps {
	className: string
	theme?: 'light' | 'dark'
	active?: boolean
}

export const MinusIcon: React.FC<IconProps> = ({ className, theme='light', active }) => {
	const state = active ? 'text-mainPink' : theme === 'light' ? 'text-black' : 'text-white'

	return (
		<svg
			className={clsx(className, state)}
			xmlns="http://www.w3.org/2000/svg"
			fill='currentColor'
			viewBox="0 0 14 3"
		>
			<path fill='currentColor' d="M0 .7395h14v2H0z"/>
		</svg>
	)
}
